/* ============
 * Package Transformer
 * ============
 *
 * The transformer for the Package.
 */

import Transformer from './transformer';

export default class packageTransformer extends Transformer {

  static fetch(pckg) {
    return {
      id: pckg.id,
      packageUnitTypeId: pckg.package_unit_type_id,
      packageUnitType: pckg.package_unit_type,
      packageUnitTypeNoCode: pckg.package_unit_type_no_code,
      parentId: pckg.parent_id,
      sscc: pckg.sscc,
      name: pckg.name,
      packingLevel: pckg.packing_level,
      numberOfProducts: pckg.number_of_products,
      totalQuantity: pckg.total_quantity,
      totalGrossWeight: pckg.total_gross_weight,
      totalNetWeight: pckg.total_net_weight,
      totalStackWeight: pckg.total_stack_weight,
    };
  }

  static send(pckg) {
    return {
      order_id: pckg.orderId,
      package_unit_type_id: pckg.packageUnitTypeId,
      parent_id: pckg.parentId,
      sscc: pckg.sscc,
      package_type: pckg.packageType,
      packing_level: pckg.packingLevel,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/package.js